module.exports = __webpack_public_path__ + "img/コンピュータのしくみII_1_6_4.102a4c35.jpeg";